"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LearnMore = _interopRequireDefault(require("./LearnMore"));
var _Social = _interopRequireDefault(require("./Social"));
var _Support = _interopRequireDefault(require("./Support"));
var _Copyright = _interopRequireDefault(require("./Copyright"));
var _footerTranslations = _interopRequireDefault(require("../footer-translations"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

// Main class export
class Footer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false
    };
    this.throttleResize = this.resize.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.throttleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.throttleResize);
  }
  renderLearnMore(data) {
    return /*#__PURE__*/_react.default.createElement(_LearnMore.default, {
      logoAlt: data.learnMore.logo.alt,
      logoSrc: data.learnMore.logo.src,
      text: data.learnMore.text,
      learnHref: data.learnMore.learn.href,
      learnText: data.learnMore.learn.text,
      textStyles: {
        padding: '24px 0 20px 0'
      }
    });
  }
  renderLearnExtra(learnExtra) {
    return /*#__PURE__*/_react.default.createElement(_LearnMore.default, {
      text: learnExtra.text ? learnExtra.text : '',
      learnHref: learnExtra.href ? learnExtra.href : '',
      learnText: learnExtra.hrefText ? learnExtra.hrefText : '',
      textStyles: {
        padding: '0 0 0 0'
      }
    });
  }
  resize() {
    clearTimeout(this.resizeReady);
    this.resizeReady = setTimeout(() => {
      this.setState({
        isMobile: window.innerWidth < 768
      });
    }, 50);
  }
  render() {
    // Drupal Footer data is inconsistent, fallback to translations if attribute from drupal menu does not exist
    const data = Object.assign(_footerTranslations.default[this.props.lang], this.props.drupalData) || _footerTranslations.default[this.props.lang] || _footerTranslations.default['en-us'];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "www-footer-com",
      style: {
        backgroundColor: '#000'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/_react.default.createElement(_Social.default, {
      list: data.footerSocial
    }), /*#__PURE__*/_react.default.createElement(_Support.default, {
      links: data.footerSupport,
      selector: _footerTranslations.default.selector,
      selectorText: data.support.selector,
      modelTitle: data.support.modelTitle,
      isMobile: this.state.isMobile
    }), /*#__PURE__*/_react.default.createElement(_Copyright.default, {
      text: data.copyright.text,
      links: data.footerCopy
    }))));
  }
}
exports.default = Footer;
;
Footer.propTypes = {
  lang: _propTypes.default.string,
  drupalData: _propTypes.default.object
};
Footer.defaultProps = {
  lang: 'en-us'
};